<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row">
  <!-- For Project creation and update evaluation sidebar tab -->
  <div class="col-md-3" *ngIf="isJdDescriptionActive || isEvaluationCriteriaActive || isSearchCriteriaActive">
    <div class="scroll-sidebar">
      <div>
        <p class="pointer text-webbtree-green" *ngIf="!isJdDescriptionActive" (click)="handleBackEvent()"> <i class="fa-regular fa-arrow-left"></i> Back</p>
        <p class="pointer text-webbtree-green" *ngIf="isJdDescriptionActive" (click)="openHandleBackEventModel()"> <i class="fa-regular fa-arrow-left"></i> Exit</p>
      </div>

      <div>
        <div class="job-desc-card pointer f-12" (click)="changeProjectCreationTab(Tab_Constants.JOB_DESCRIPTION_TAB)"
          [ngClass]="isJdDescriptionActive ? 'active' : '' ">
          <span *ngIf="isJdDescriptionActive"><i class="fa-solid fa-file-pen"></i></span>
          <span *ngIf="!isJdDescriptionActive">
            <i class="fa-solid fa-file-pen"></i>
          </span>
          <span>Enter Job Description</span>
        </div>

        <div class="job-desc-card pointer f-12" (click)="changeProjectCreationTab(Tab_Constants.SEARCH_CRITERIA_TAB)"
          [ngClass]="isSearchCriteriaActive ? 'active' : '' ">
          <span><i class="fa-regular fa-sliders"></i></span>
          <span>Review Autopilot<sup style="top: -1px!important;"><span>AI</span></sup> Search Criteria</span>
        </div>


        <div class="job-desc-card pointer f-12" (click)="changeProjectCreationTab(Tab_Constants.EVALUATION_CRITERIA_TAB)"
          [ngClass]="isEvaluationCriteriaActive ? 'active' : '' ">
          <span *ngIf="!isEvaluationCriteriaActive"><i class="fa-regular fa-stars"></i></span>
          <span *ngIf="isEvaluationCriteriaActive"><i class="fa-solid fa-stars"></i></span>
          <span>Enter Autopilot<sup style="top: -1px!important;"><span>AI</span></sup> Evaluation Criteria</span>
        </div>
      </div>

      <div *ngIf="isEvaluationCriteriaActive" [ngClass]="isEvaluationCriteriaActive ? 'evaluation-sticky':''">
        <app-evaluation-slider></app-evaluation-slider>
        <!-- <app-exploring-evaluation-criteria></app-exploring-evaluation-criteria> -->
      </div>
    </div>
  </div>

  <!-- Ai Sourcing page view -->
  <div class="col-md-3 pr-0" *ngIf="isAISourcingInsightsActive">
    <app-insights-sidebar [showSummary]="showAiSummary"></app-insights-sidebar>
  </div>

  <!-- Filter component Sidebar -->
  <div class="col-md-3 pr-0" *ngIf="isAISourcingProfilesActive">
    <div class="companyCompareStick">
      <app-person-search-filter [showAISourcingBackButton]="isAISourcingProfilesActive"></app-person-search-filter>
    </div>
  </div>

  <!-- All the routing page view -->
  <div [ngClass]="
          isAISourcingInsightsActive ||
          isAISourcingProfilesActive
            ? 'col-md-9'
            : 'col'
        ">
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>


<!-- For back event model -->
<ng-template #handleBackEventModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Are you sure you want to exit?
      </span>
      <!-- <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span> -->
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <p class="f-14 ">Unsaved progress will be lost.</p>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-ai-sourcing-button-1" class="btn-trms-white mr-3" (click)="handleBackEvent()">Confirm</button>
        <button data-testid="auto-app-ai-sourcing-button-2" class="btn-trms-small" (click)="dismiss()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- For back event model -->
<ng-template #handleBackEventForCriteriaModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600"></span>
      <!-- <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span> -->
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <p class="f-14 ">AI evaluation criteria you’ve entered will be lost if you go back. Do you want to go back</p>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-ai-sourcing-button-3" class="btn-trms-white mr-3" (click)="confirmBackFromEvaluationPage(evaluationCriteriaBackTab)">Confirm</button>
        <button data-testid="auto-app-ai-sourcing-button-4" class="btn-trms-small" (click)="dismiss()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>
